import React, { useEffect, useRef } from "react";
import { Button } from "@progress/kendo-react-buttons";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import FormTextField from "../../components/formFields/FormTextField";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import { clearDesignationDetails } from "./designationSlice";
import {
  createDesignation,
  getAllActiveDesignations,
  getAllDesignations,
  getDesignationByID,
  updateDesignation,
} from "./services/designation.services";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
// import { closed } from "../../components/drawer/drawerSlice";

const CreateDesignation: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  const DesignationDetail = useAppSelector(
    (state) => state.designation.DesignationDetail
  );
  const designation_guid = useAppSelector((state) => state.muidrawer.data);
  const formLoading = useAppSelector((state) => state.designation.formLoading);
  const isIndirect = useAppSelector((state) => state.muidrawer.isIndirect);

  useEffect(() => {
    return () => {
      dispatch(clearDesignationDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (designation_guid) {
      dispatch(getDesignationByID(designation_guid));
    }
  }, [designation_guid]);

  const handleSubmit = async (values: any) => {
    try {
      if (!designation_guid) {
        const insertPayload = {
          designation_name: values.designation_name,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(createDesignation(insertPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearDesignationDetails());
          isIndirect
            ? dispatch(getAllActiveDesignations())
            : dispatch(getAllDesignations());
        }
      } else {
        const editPayload = {
          id: values?.id,
          designation_guid: designation_guid,
          designation_name: values.designation_name,
          isactive: values.isactive === 1,
        };
        const response = await dispatch(updateDesignation(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearDesignationDetails());
          isIndirect
            ? dispatch(getAllActiveDesignations())
            : dispatch(getAllDesignations());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={DesignationDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                margin: "17px 0 8px",
              }}
            >
              <Typography.h4 className="m-0">
                {designation_guid ? "Update Designation" : "Add Designation"}
              </Typography.h4>
              <Button
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4 }}
                onClick={() => dispatch(closed())}
              >
                <RxCross1 />
              </Button>
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="designation_name"
                label="Designation Name"
                placeholder="Designation Name"
                component={FormTextField}
                validator={requiredValidator} astrike={true}
              />
            </GridLayoutItem>

            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"isactive"}
                name={"isactive"}
                label={"Status"}
                component={FormSelectionField}
                validator={requiredValidator} astrike={true}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={3}
              style={{
                textAlign: "start",
                marginTop: "20px",
                width: "100%",
              }}
            >
              <ButtonWithLoading
                label={designation_guid ? "Update" : "Save"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginLeft: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateDesignation;
